import React, { useState } from "react"
import PropTypes from "prop-types"
import TextField from "@mui/material/TextField"
import Chip from "@mui/material/Chip"
import Box from "@mui/material/Box"
import { StyledTagsInput } from "./TagsInput.style"

const TagsInput = ({ tags, setTags }) => {
  const [inputValue, setInputValue] = useState("")

  const handleOnChange = (newTags) => {
    // Convert strings to objects with text property to match the expected format
    const formattedTags = newTags.map(tag => 
      typeof tag === 'string' ? { text: tag } : tag
    )
    setTags(formattedTags)
  }

  // Extract text values from tag objects
  const tagValues = tags.map(tag => 
    typeof tag === 'object' && tag.text ? tag.text : tag
  )

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' || event.key === ',') {
      event.preventDefault()
      const newTag = inputValue.trim()
      if (newTag && !tagValues.includes(newTag)) {
        const updatedTags = [...tagValues, newTag]
        handleOnChange(updatedTags)
        setInputValue("")
      }
    }
  }

  const handleDelete = (tagToDelete) => {
    const updatedTags = tagValues.filter(tag => tag !== tagToDelete)
    handleOnChange(updatedTags)
  }

  return (
    <StyledTagsInput>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center' }}>
        {tagValues.map((tag, index) => (
          <Chip
            key={index}
            label={tag}
            onDelete={() => handleDelete(tag)}
            size="small"
            sx={{ margin: 0.5 }}
          />
        ))}
        <TextField
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Add New Tag Here ..."
          variant="standard"
          size="small"
          sx={{ minWidth: 150, flex: 1 }}
        />
      </Box>
    </StyledTagsInput>
  )
}

TagsInput.propTypes = {
  tags: PropTypes.array.isRequired,
  setTags: PropTypes.func.isRequired,
}

export default TagsInput
